<div *ngFor="let item of calls">
  <mat-card
    class="list-call-item clickable"
    (dblclick)="goToCall(item.identifier)"
    [style.borderBottomColor]="borderColorByState(item)"
    matRipple
  >
    <mat-card-title>
      <div class="list-os-item-title">
        <div class="clickable" (click)="goToCall(item.identifier)">
          <small
            ><b>#{{ item.number }}</b></small
          >
        </div>

        <div class="badges">
          <span
            [class]="classesByState(item)"
            class="badges-item"
            [matMenuTriggerFor]="statuses"
          >
            {{ item.status_detail.text }}
          </span>
        </div>
      </div>
      <div style="width: 100%; display: flex; justify-content: end">
        <small>
          {{ item.open_since }}
        </small>
      </div>
    </mat-card-title>

    <div class="list-os-item-infos" style="margin-bottom: 0">
      <div>
        <b> <small>Empresa:</small></b> <br />
        {{ item.business.name }}
      </div>
      <div>
        <b> <small>Atendente:</small></b> <br />
        {{ item.user.name }}
      </div>
    </div>

    <div class="list-os-item-infos" style="margin-bottom: 0">
      <div>
        <b> <small>Solicitante:</small></b>
        <br />
        {{ item.business_user.name }}
      </div>
      <div>
        <b> <small>Tipo:</small></b>
        <br />
        {{ item.type_detail.text }}
      </div>
    </div>

    <mat-menu #statuses="matMenu" class="status-menu">
      <button *ngFor="let status of statusColors" mat-menu-item>
        {{ status.status }}
      </button>
    </mat-menu>
  </mat-card>
</div>
